<template>
  <el-dialog v-if="dialogFormVisible" v-el-drag-dialog class="select-ztree-dialog" :visible.sync="dialogFormVisible" :close-on-click-modal="false" :width="winWidth+'px'" :title="dialogTitle" :append-to-body="true" @close="closeDialog">
    <div v-if="loading" v-loading="loading" class="el-dialog__body" style="height:366px" />
    <div v-if="!loading" class="select-dialog-container">

      <el-row class="searchdoing" :class="fontMagnify?'font-magnify':''">
        <el-col class="ztree-container" :span="13">
          <div class="treeNode">
            <el-row v-if="showSearchInput">
              <el-col span="24" class="search-input-container">
                <el-input v-model="searchkey" size="small" placeholder="请输入搜索关键字" @keyup.enter.native="searchTreeNode">
                  <el-select v-if="showSelectByTabs" slot="prepend" v-model="selectByTabsActiveName" placeholder="请选择" @change="onSelectByTabsHandleClick">
                    <el-option label="按机构" value="byOrg" />
                    <el-option label="按群组" value="byWorkgroup" />
                    <el-option label="按岗位" value="byJobPosition" />
                  </el-select>
                </el-input>
              </el-col>
            </el-row>
            <el-scrollbar tag="div" :class="showSearchInput?'':'no-search-input'">
              <el-tree
                v-if="searchDoing"
                ref="searchOrgTree"
                :data="searchedData"
                :props="searchTreeProps"
                :empty-text="searchedData?'暂无数据':'正在搜索...'"
                :show-checkbox="true"
                :check-strictly="checkStrictly"
                node-key="id"
                :default-expanded-keys="defaultExpandedKeys"
                :default-checked-keys="defaultCheckedKeys"
                :filter-node-method="filterOrgTreeNode"
                @node-click="onTreeNodeClick"
                @check="onTreeNodeCheck"
              >
                <span slot-scope="{ data }" class="tree-node-icon">
                  <i v-if="data.icon" :class="data.icon" />
                  <span>{{ data.title }}</span>
                </span>
              </el-tree>
              <el-tree
                v-show="!searchDoing"
                ref="orgTree"
                :class="hiddenFolderCheckbox?'hidden-folder-checkbox':''"
                :props="treeProps"
                :load="loadNode"
                empty-text="暂无数据"
                :lazy="lazy"
                :data="lazy?null:treeData"
                :show-checkbox="true"
                :check-strictly="checkStrictly"
                node-key="id"
                :default-expanded-keys="defaultExpandedKeys"
                :default-checked-keys="defaultCheckedKeys"
                :filter-node-method="filterOrgTreeNode"
                @node-click="onTreeNodeClick"
                @node-expand="onTreeNodeExpand"
                @check="onTreeNodeCheck"
              >
                <span slot-scope="{ data }" class="tree-node-icon">
                  <i v-if="data.icon" :class="data.icon" />
                  <span>{{ data.name }}</span>
                </span>
              </el-tree>
            </el-scrollbar>
          </div>
        </el-col>
        <el-col class="ztree-container" :span="11">
          <el-scrollbar class="treeNode" tag="div" style="border-left:0px;">
            <div class="selectedNodes">
              <div class="selected-title">已选择</div>
              <template>
                <div v-for="(selectedNode,selectedNodeKey) in selectedNodes" :key="selectedNodeKey" class="selectedNode">
                  <div class="node-text" :title="selectedNode.staffFullName ||selectedNode.title">{{ selectedNode.staffFullName ||selectedNode.title }}</div>
                  <i :key="selectedNodeKey" class="el-icon-close" type="danger" @click="removeSelectedNode(selectedNode)" />
                </div>
              </template>
              <div v-show="!selectedNodes||selectedNodes.length===0">暂无选择</div>
            </div>
          </el-scrollbar>
        </el-col>
      </el-row>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button plain icon="el-icon-close" @click="closeDialog">取 消</el-button>
      <el-button type="primary" icon="el-icon-check" @click="submitForm">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    components: {

    },
    props: {
        winWidth: { type: Number, default: 600 }
    },
    data() {
        return {
            dialogTitle: '', // 弹窗标题
            dialogName: null, // 弹窗Name
            dialogFormVisible: false,
            loading: false,
            el: null,
            binding: null,
            vnode: null,
            callback: null, // 回调函数
            treeData: null, // 树数据
            treeDataMap: {}, // 树数据id-value
            defaultExpandedKeys: [], // 默认展开的节点ID
            defaultCheckedKeys: [], // 默认选中的节点ID
            byOrgTreeData: null, // 工作流-按机构选择树数据
            byWgTreeData: null, // 工作流-按群组选择树数据
            byJbTreeData: null, // 工作流-按岗位选择树数据
            treeProps: {
                children: 'children',
                label: 'name',
                isLeaf: this.isLeafNode
            },
            searchTreeProps: {
                children: 'children',
                label: 'title',
                isLeaf: this.isLeafNode
            },
            lazy: false,
            checkStrictly: true, // 是否级联选择
            multiple: false, // 是否多选
            onebyone: false, // 每部门/每组限选一人
            hiddenFolderCheckbox: false, // 是否隐藏文件夹复选框
            prevSelected: [],
            searchkey: '', // 搜索
            searchedData: null, // 搜索结果
            selectedNodes: [], // 已选择数据
            selectedOrderBy: 'orgOrderNo', // 多选人员排序方式，默认按组织机构人员排序
            isStaffExt: false, // 是否人员选择扩展模式
            rootTreeData: null, // 人员选择扩展部门数据
            selectRootOrg: -1, // 被选择的公司
            rootOrgList: [], // 所有公司列表
            subOrgList: {}, // 已加载子机构
            folderUser: '/plugins/zTree/css/img/folder_user.png',
            user: '/plugins/zTree/css/img/user.png',
            searchDoing: false,
            indeterminate: false,
            showSelectAllNodes: false, // 是否显示全选复选框
            selectAllNodes: false, // 全选状态
            showSearchInput: true, // 是否显示搜索框
            fontMagnify: false, // 是否自定义标题字体
            openSysCode: '', // 仅显示开通指定系统的人员
            showSelectByTabs: false, // 是否显示按机构、按群组、按岗位选择人员切换标签，仅流程提交办理选择单位全体人员时有效
            selectByTabsActiveName: 'byOrg'
        }
    },
    computed: {
        ...mapGetters([
            'loginUser'
        ])
    },
    watch: {
    },
    created() {
        this.$bus.on('openOrgStaffSelectDialog1', this.openSelectDialog)
    },
    beforeDestroy() {
        this.$bus.off('openOrgStaffSelectDialog1', this.openSelectDialog)
    },
    mounted() {
    },
    methods: {
        async openSelectDialog(el, binding, vnode) {
            const _this = this
            if (_this.loading) {
                return
            }

            if (window.fontMagnify) this.fontMagnify = true
            this.loading = true
            this.dialogFormVisible = true
            this.isStaffExt = false
            this.searchedData = null
            this.searchDoing = false
            this.checkStrictly = true
            this.hiddenFolderCheckbox = false
            this.defaultCheckedKeys = []
            this.defaultExpandedKeys = []
            this.lazy = false

            this.el = el
            this.binding = binding
            this.vnode = vnode
            this.multiple = el.attrs.multiple
            if (binding.value === 'wfNodeUser') {
                this.checkStrictly = false// 流程选择处理人允许级联
            }
            this.selectedOrderBy = el.attrs['selected-order-by'] || this.selectedOrderBy

            /* if (!this.multiple && binding.value === 'wfNodeUser') {
                this.hiddenFolderCheckbox = true
            } else */
            if (binding.value === 'staff' || binding.value === 'staffExt' || binding.value === 'jobPositionStaff' || binding.value === 'workgroupStaff' || binding.value === 'allStaff' || binding.value === 'rootorg') {
                this.hiddenFolderCheckbox = true
            }

            let searchInput = null
            if (el.attrs['search-input'] === 'true')searchInput = true
            if (el.attrs['search-input'] === 'false') searchInput = false

            if (el.attrs['only-cur-sys'] !== 'false' && el.attrs['only-cur-sys'] !== false) {
                if (vnode.context.$parent.wfInstance) {
                    this.openSysCode = vnode.context.$parent.wfInstance.sysCode
                } else if (vnode.context.process && vnode.context.process.sysCode) {
                    this.openSysCode = vnode.context.process.sysCode
                } else if (vnode.context.vo && vnode.context.vo.sysCode) {
                    this.openSysCode = vnode.context.vo.sysCode
                } else if (this.loginUser.sysCode !== 'eccloud') {
                    this.openSysCode = this.loginUser.sysCode
                }
            }

            if (this.multiple === 'true') this.multiple = true
            if (this.multiple === 'false') this.multiple = false

            if (el.attrs.onebyone === '1') {
                this.onebyone = true
            } else {
                this.onebyone = false
            }

            if (el.attrs['dialog-width'] && !isNaN(Number(el.attrs['dialog-width']))) this.winWidth = Number(el.attrs['dialog-width'])

            let reqParams = null
            if (!this.multiple || this.multiple === 'false' || el.attrs.onebyone === '1') {
                this.showSelectAllNodes = false
            } else if (binding.value === 'staff' || binding.value === 'wfNodeUser' || binding.value === 'staffExt' || binding.value === 'workgroupStaff' || binding.value === 'jobPositionStaff') {
                this.showSelectAllNodes = true
            } else {
                this.showSelectAllNodes = false
            }

            if (el.attrs['checkall-checkbox'] === 'true') this.showSelectAllNodes = true
            if (el.attrs['checkall-checkbox'] === 'false') this.showSelectAllNodes = false

            if (binding.value === 'staff' && el.attrs['org-level'] === '0') {
                binding.value = 'staffExt'
            }

            if (binding.value === 'allStaff' || binding.value === 'allOrg' || binding.value === 'allNode' || binding.value === 'curOrgNode') {
                this.winWidth = 700
                this.lazy = true

                if (binding.value === 'allStaff') {
                    this.dialogTitle = '选择人员'
                    this.callback = 'onSelectStaffCompleted'
                } else if (binding.value === 'allOrg') {
                    this.dialogTitle = '选择机构'
                    this.callback = 'onSelectAllOrgCompleted'
                } else {
                    this.dialogTitle = '选择机构人员'
                    this.callback = 'onSelectAllNodeCompleted'
                }
                this.dialogName = 'treeDialog'

                reqParams = {
                    method: 'GET',
                    url: 'base/organMgr/findTreeNodeVOListByNodeId', // 加载目录树节点(TreeNode对象)url
                    params: { status: 1 }// 查询条件
                }
                if (binding.value === 'curOrgNode') {
                    let orgCode = this.el.attrs['root-org-code']
                    if (orgCode === undefined) {
                        orgCode = this.loginUser.orgCode
                    }
                    reqParams.url = 'base/organMgr/findTreeNodeVOListByOrgCode'
                    reqParams.params['orgCode'] = orgCode
                }

                // 树节点级别
                if (el.attrs['node-level']) {
                    reqParams.params['nLevelFilter'] = Number(el.attrs['node-level'])
                }
                // 节点ID
                if (el.attrs['node-id']) {
                    reqParams.params['nodeId'] = el.attrs['node-id']
                    reqParams.params['self'] = true
                }
            } else if (binding.value === 'treeNode') {
                this.dialogTitle = '选择机构目录'
                this.dialogName = 'treeDialog'

                reqParams = {
                    method: 'GET',
                    url: 'base/organMgr/findTreeNodeVOListByNodeId', // 加载目录树节点(TreeNode对象)url
                    params: { type: 'treeNode', status: 1 }// 查询条件
                }
                // 树节点级别
                if (el.attrs['node-level']) {
                    reqParams.params['nLevelFilter'] = Number(el.attrs['node-level'])
                }
                // 节点ID
                if (el.attrs['node-id']) {
                    reqParams.params['nodeId'] = el.attrs['node-id']
                    reqParams.params['self'] = true
                }
                this.callback = 'onSelectTreeNodeCompleted'
            } else if (binding.value === 'rootorg') {
                this.dialogTitle = '选择机构'
                this.dialogName = 'treeDialog'

                reqParams = {
                    method: 'GET',
                    url: 'base/organMgr/findTreeNodeVOListByNodeId', // 加载目录树节点(TreeNode、Oragnization两类对象)url
                    params: { status: 1 }// 查询条件
                }
                // 节点级别
                if (el.attrs['node-level']) {
                    reqParams.params['nLevelFilter'] = Number(el.attrs['node-level'])
                }
                // 节点ID
                if (el.attrs['node-id']) {
                    reqParams.params['nodeId'] = el.attrs['node-id']
                    reqParams.params['self'] = true
                }

                this.callback = 'onSelectRootorgCompleted'
            } else if (binding.value === 'suborg') {
                this.dialogTitle = '选择部门'
                this.dialogName = 'treeDialog'

                let orgCode = this.el.attrs['root-org-code']
                if (orgCode === undefined) {
                    orgCode = this.loginUser.orgCode
                }

                const params = { orgCode: orgCode }
                if (el.attrs['org-level'] !== undefined) {
                    const orgLevel = el.attrs['org-level'].split(',')
                    params.subOrgLevel = orgLevel[orgLevel.length - 1]
                }
                reqParams = {
                    method: 'GET',
                    url: 'base/organMgr/findAllOrganByOrgCode', // 加载部门/科室/班组树节点(Oragnization)url
                    params: params // 查询条件
                }

                this.callback = 'onSelectSuborgCompleted'
            } else if (binding.value === 'workgroup') {
                this.dialogTitle = '选择工作群组'
                this.dialogName = 'listitemDialog'

                let orgCode = this.el.attrs['root-org-code']
                if (orgCode === undefined) {
                    orgCode = this.loginUser.orgCode
                }

                reqParams = {
                    method: 'POST',
                    url: 'base/workGroup/querydata', // 加载工作群组列表(WorkGroup对象)url
                    data: [{ field: 'orgCode', compare: '=', value: orgCode }, { field: 'status', compare: '=', value: 1 }]// 查询条件
                }

                this.callback = 'onSelectWorkgroupCompleted'
            } else if (binding.value === 'jobPosition') {
                this.dialogTitle = '选择工作岗位'
                this.dialogName = 'listitemDialog'

                let orgCode = this.el.attrs['root-org-code']
                if (orgCode === undefined) {
                    orgCode = this.loginUser.orgCode
                }

                reqParams = {
                    method: 'POST',
                    url: 'base/jobPosition/querydata', // 加载工作岗位列表(JobPosition对象)url
                    data: [{ field: 'orgCode', compare: '=', value: orgCode }, { field: 'status', compare: '=', value: 1 }]// 查询条件
                }

                this.callback = 'onSelectJobPositionCompleted'
            } else if (binding.value === 'staff') {
                this.dialogTitle = '选择人员'
                this.dialogName = 'treeDialog'
                const treeData = this.el.attrs['init-tree-data']
                if (treeData === undefined) {
                    const orgId = this.el.attrs['org-id']
                    const orgLevel = this.el.attrs['org-level']
                    const subOrgName = this.el.attrs['sub-org-name']
                    const orgSelf = this.el.attrs['org-self']
                    let orgCode = this.el.attrs['root-org-code']

                    if (orgCode === undefined) {
                        orgCode = this.loginUser.orgCode
                    }

                    if (orgLevel === 1 || orgLevel === '1') {
                        reqParams = {
                            method: 'GET',
                            url: 'base/organMgr/findOrgLeaderByOrgCode', // 加载部门/科室/班组树节点(Oragnization)url
                            params: { orgCode: orgCode, self: orgSelf }// 查询条件
                        }
                    } else if (orgLevel === 2 || orgLevel === '2') {
                        this.orgId = ''
                        if (vnode.context.$parent.curTN) {
                            this.orgId = vnode.context.$parent.curTN.staffOrgID.split('-')[1]
                        } else {
                            this.loginUser.staffList.forEach(staff => {
                                this.orgId += (this.orgId === '' ? '' : ',') + staff.orgFullId.split('-')[1]
                            })
                        }
                        reqParams = {
                            method: 'GET',
                            url: 'base/organMgr/findOrganPersonByOrgId', // 加载部门/科室/班组树节点(Oragnization)url
                            params: { orgId: this.orgId, self: orgSelf }// 查询条件
                        }
                    } else if (orgId !== undefined && orgId !== null && orgId !== '') {
                        reqParams = {
                            method: 'GET',
                            url: 'base/organMgr/findOrganPersonByOrgId', // 加载部门/科室/班组树节点(Oragnization)url
                            params: { orgId: orgId, self: orgSelf }// 查询条件
                        }
                    } else if (subOrgName !== undefined && subOrgName !== null && subOrgName !== '') {
                        reqParams = {
                            method: 'GET',
                            url: 'base/organMgr/findOrganPersonBySubOrgName', // 加载部门/科室/班组树节点(Oragnization)url
                            params: { orgCode: orgCode, subOrgName: subOrgName, self: orgSelf }// 查询条件
                        }
                    } else {
                        reqParams = {
                            method: 'GET',
                            url: 'base/organMgr/findOrganPersonByOrgCode', // 加载部门/科室/班组树节点(Oragnization)url
                            params: { orgCode: orgCode, self: orgSelf }// 查询条件
                        }
                    }
                    reqParams.params.openSysCode = this.openSysCode
                }

                this.callback = 'onSelectStaffCompleted'
            } else if (binding.value === 'jobPositionStaff') {
                this.dialogTitle = '选择人员'
                this.dialogName = 'treeDialog'

                let orgCode = this.el.attrs['root-org-code']
                if (orgCode === undefined) {
                    orgCode = this.loginUser.orgCode
                }

                reqParams = {
                    method: 'GET',
                    url: 'base/organMgr/findOrganPersonByJobPosition', // 加载工作岗位人员url
                    params: { orgCode: orgCode, jobPositionCode: this.el.attrs['job-position-code'] }// 查询条件
                }

                this.callback = 'onSelectStaffCompleted'
            } else if (binding.value === 'workgroupStaff') {
                this.dialogTitle = '选择人员'
                this.dialogName = 'treeDialog'

                let orgCode = this.el.attrs['root-org-code']
                if (orgCode === undefined) {
                    orgCode = this.loginUser.orgCode
                }

                reqParams = {
                    method: 'GET',
                    url: 'base/organMgr/findOrganPersonByWorkgroup', // 加载工作群组成员url
                    params: { orgCode: orgCode, workgroupCode: this.el.attrs['workgroup-code'] }// 查询条件
                }

                this.callback = 'onSelectStaffCompleted'
            } else if (binding.value === 'wfNodeUser') {
                this.dialogTitle = '选择人员'
                this.dialogName = 'treeDialog'
                this.showSelectByTabs = this.el.attrs['show-select-by-tabs']
                this.selectByTabsActiveName = 'byOrg'

                let asyncOrgId = ''
                const wfNodeUsers = this.el.attrs['init-tree-data']
                wfNodeUsers.forEach(wfUser => {
                    if (wfUser.type === 'asyncLoadingUsers') {
                        asyncOrgId += (asyncOrgId === '' ? '' : ',') + (wfUser.orgId || wfUser.parentId)
                    }
                })
                if (asyncOrgId !== '') {
                    if (asyncOrgId === 'group') { // 全集团
                        let orgCode = this.el.attrs['root-org-code']
                        if (orgCode === undefined) {
                            orgCode = this.loginUser.orgCode
                        }

                        reqParams = {
                            method: 'GET',
                            url: 'base/organMgr/findOrganPersonForGroupOrg', // 加载部门/科室/班组树节点(Oragnization)url
                            params: { orgCode: orgCode }// 查询条件
                        }
                    } else { // 指定机构ID
                        reqParams = {
                            method: 'GET',
                            url: 'base/organMgr/findOrganPersonByOrgId', // 加载部门/科室/班组树节点(Oragnization)url
                            params: { orgId: asyncOrgId, self: asyncOrgId.split(',').length > 1 }// 查询条件
                        }
                    }

                    reqParams.params.openSysCode = this.openSysCode
                }

                this.callback = 'onSelectWfNodeUserCompleted'
            } else if (binding.value === 'staffExt') {
                this.dialogTitle = '选择人员(扩展)'
                this.dialogName = 'treeDialog'
                this.lazy = true

                let orgCode = this.el.attrs['root-org-code']
                if (orgCode === undefined) {
                    orgCode = this.loginUser.orgCode
                }
                const oldValue = this.vnode.data.attrs['old-value'] || ''
                reqParams = {
                    url: 'base/organMgr/findGroupOrganByOrgCode',
                    method: 'POST',
                    contentType: 'application/x-www-form-urlencoded',
                    params: { orgCode: orgCode },
                    data: oldValue.split(',')
                }

                this.callback = 'onSelectStaffCompleted'
            } else if (binding.value === 'suborgExt') {
                this.dialogTitle = '选择部门(扩展)'
                this.dialogName = 'treeDialog'

                let orgCode = this.el.attrs['root-org-code']
                if (orgCode === undefined) {
                    orgCode = this.loginUser.orgCode
                }
                const params = { orgCode: 'group_all_corp:' + orgCode, subOrgLevel: 2 }
                if (el.attrs['org-level'] !== undefined) {
                    const orgLevel = el.attrs['org-level'].split(',')
                    params.subOrgLevel = orgLevel[orgLevel.length - 1]
                }

                reqParams = {
                    url: 'base/organMgr/findAllOrganByOrgCode',
                    method: 'GET',
                    contentType: 'application/x-www-form-urlencoded',
                    params: params
                }

                this.callback = 'onSelectSuborgCompleted'
            } else {
                this.dialogName = el.attrs['dialog-class'] || 'treeDialog'
                this.callback = 'on' + binding.value[0].toUpperCase() + binding.value.substring(1) + 'Completed'
            }

            if (el.attrs['dialog-title'] !== undefined) {
                this.dialogTitle = el.attrs['dialog-title']
            }

            if (reqParams !== null) {
                this.$http(reqParams).then(res => {
                    if (res.code === 'success') {
                        if (binding.value === 'rootorg' || binding.value === 'allNode' || binding.value === 'allOrg' || binding.value === 'allStaff' || binding.value === 'staffExt' || binding.value === 'suborgExt') {
                            const nodeIds = []

                            for (let i = 0; i < res.body.listdata.length; i++) {
                                const node = res.body.listdata[i]
                                if (node.type === 'rootOrg') {
                                    if (node.fullID && node.fullID.indexOf('-') > 0) {
                                        node.isLeaf = 1

                                        node.fullID.split('-').forEach(id => {
                                            if (nodeIds.indexOf(id) === -1) {
                                                nodeIds.push(id)
                                            }
                                        })
                                    } else {
                                        // 未关联treeNode的根机构，不显示
                                        res.body.listdata.splice(i--, 1)
                                    }
                                }
                            }

                            const listdata = res.body.listdata.filter(node => {
                                // 过滤掉不包含机构的目录树节点
                                if (node.type !== 'treeNode' || nodeIds.indexOf(node.id) !== -1) {
                                    return true
                                }
                            })

                            _this.treeData = _this.treeDataAdapter(listdata)
                            _this.showSearchInput = searchInput !== null ? searchInput : this.treeData.filter(node => !node.personId).length > 1
                        } else {
                            _this.treeData = _this.treeDataAdapter(res.body.listdata)
                            _this.showSearchInput = searchInput !== null ? searchInput : this.treeData.filter(node => !node.personId).length > 1
                        }
                    } else {
                        this.$alert(res.message, { type: 'error' })
                    }

                    _this.$nextTick(() => {
                        _this.loading = false
                        if (_this.lazy && this.prevSelected.length > 0 && this.prevSelected[0] !== '') {
                            this.lazyLoadDefaultChecked(this.prevSelected)
                        }
                    })
                })
            } else {
                _this.treeData = this.treeDataAdapter(_this.el.attrs['init-tree-data'])
                this.showSearchInput = searchInput !== null ? searchInput : this.treeData.filter(node => !node.personId).length > 1
                _this.$nextTick(() => {
                    _this.loading = false
                })
            }
        },
        treeDataAdapter(allTreeData) {
            const _this = this
            const attr = this.el.attrs
            let treeData = JSON.parse(JSON.stringify(allTreeData))

            if (this.vnode.context.onSelectTreeDataLoaded) {
                treeData = this.vnode.context.onSelectTreeDataLoaded(treeData, attr)
            } else if (this.vnode.context.$vnode.context.onSelectTreeDataLoaded) {
                treeData = this.vnode.context.$vnode.context.onSelectTreeDataLoaded(treeData, attr)
            } else if (this.$vnode.context.$vnode.context.$vnode.context.onSelectTreeDataLoaded) {
                treeData = this.vnode.context.$vnode.context.$vnode.context.onSelectTreeDataLoaded(treeData, attr)
            }

            // 已经选择的值
            this.prevSelected = this.getPrevSelected()
            for (let i = 0; i < treeData.length; i++) {
                const node = treeData[i]

                this.treeDataMap[node.id] = node

                node.checked = false
                if (node.type) node.type = node.type.replace(/\s*/g, '')

                if (node.personId) {
                    node.pId = node.groupId || node.parentId || node.orgId
                    // node.icon = this.user
                    node.canSelect = true
                    if (attr.showmobile === true || attr.showmobile === 'true') {
                        if (node.mobile == null) node.mobile = '无'
                        node.name = node.name + '<' + (node.mobile === null ? '无' : node.mobile) + '>'
                        node.title = node.name
                    }
                    if (attr.showemail === true || attr.showemail === 'true') {
                        if (node.email === null) node.email = '无'
                        node.name = node.name + '<' + node.email + '>'
                        node.title = node.name
                    }
                    if (attr.showaccount === true || attr.showaccount === 'true') {
                        if (node.account === null) node.account = '无'
                        node.name = node.name + '<' + node.account + '>'
                        node.title = node.name
                    }

                    if (!node.title) {
                        let pname = (node.fullName || node.orgFullName).replace(/[&\|\\\*^%$#@\-]/g, '-')
                        pname = pname.substring(node.orgFullName.indexOf('-') + 1)
                        node.title = pname + '\\' + node.name
                    }

                    if (this.binding.value === 'allStaff' || this.binding.value === 'allNode' || this.binding.value === 'staffExt') {
                        node.title = node.name + ' ' + node.orgFullName
                    } else if (this.binding.value === 'curOrgNode') {
                        node.title = node.name + ' ' + node.orgFullName.substring(node.orgFullName.indexOf('-') + 1)
                    }
                } else if (this.binding.value === 'allStaff' || this.binding.value === 'staff' || this.binding.value === 'staffExt' || this.binding.value === 'allOrg' || this.binding.value === 'allNode' || this.binding.value === 'curOrgNode' || this.binding.value === 'treeNode' || this.binding.value === 'rootorg' ||
                this.binding.value === 'wfNodeUser' || this.binding.value === 'jobPositionStaff' || this.binding.value === 'workgroupStaff') {
                    // 选择机构目录、主机构
                    node.pId = node.pId || node.parentID || node.parentId || -1
                    node.name = node.nName || node.name

                    if (this.searchkey || node.type === 'subOrg') {
                        node.title = (node.fullName || node.orgFullName).replace(/[&\|\\\*^%$#@\-]/g, '-')
                    } else if (this.binding.value === 'wfNodeUser' && !node.personId) {
                        node.title = node.orgFullName.substring(node.orgFullName.indexOf('-') + 1)
                    } else {
                        node.title = node.name
                    }

                    if (this.binding.value === 'rootorg' && node.type === 'rootOrg') {
                        node.canSelect = true
                    } else if (this.binding.value === 'allOrg' || this.binding.value === 'allNode' || this.binding.value === 'curOrgNode' || this.binding.value === 'treeNode') {
                        node.canSelect = true
                    } else if (this.binding.value === 'wfNodeUser' && (!this.multiple || this.onebyone || this.selectedOrderBy === 'selectedIndex')) {
                        node.disabled = true
                    }

                    if (this.binding.value === 'allStaff' || this.binding.value === 'staff' || this.binding.value === 'staffExt' || this.binding.value === 'jobPositionStaff' || this.binding.value === 'workgroupStaff') {
                        if (node.type === 'subOrg' || node.orgLevel > 1 || node.olevel > 1) {
                            node.icon = 'el-icon-user'
                        }
                    }
                } else if (this.binding.value === 'suborg' || this.binding.value === 'suborgExt') {
                    // 选择部门/科室/班组
                    let levels = attr['org-level']
                    if (levels === undefined) {
                        attr['org-level'] = '2'
                        levels = '2'
                    } else {
                        levels = levels.split(',')
                    }

                    node.pId = node.parentId || node.parentID
                    node.title = node.orgFullName || node.fullName
                    node.name = node.name || node.nName
                    node.title = node.title.replace(/[&\|\\\*^%$#@\-]/g, '-')

                    if (this.binding.value === 'suborg' && node.title.indexOf('-') !== -1) {
                        node.title = node.title.substring(node.title.indexOf('-') + 1)
                    }

                    if (attr['org-level'].indexOf(node.orgLevel + '') === -1 && attr['org-level'].indexOf(node.olevel + '') === -1) {
                        node.disabled = true
                    }

                    if (node.orgLevel === 1 || node.olevel === 1) {
                        // 第一级打开
                        node.open = true
                    } else if (attr['org-level'].indexOf(node.orgLevel + '') !== -1 || attr['org-level'].indexOf(node.olevel + '') !== -1) {
                        // 允许选择
                        if (node.isRealOrg !== 0) {
                            node.canSelect = true
                        }
                    } else if (node.orgLevel > levels[levels.length - 1] || node.olevel > levels[levels.length - 1]) {
                        // 小于指定的机构级别，删除
                        treeData.splice(i--, 1)
                    }
                } else {
                    // 选择(工作岗位、组织机构)列表
                    node.title = node.title || node.name
                    node.canSelect = (node.canSelect === true || node.canSelect === false) ? node.canSelect : true
                    node.icon = node.icon || ''
                    node.pId = node.pId || node.parentId || ''
                    this.showIcon = (node.showIcon === true || node.showIcon === false) ? node.showIcon : false
                    this.showLine = (node.showLine === true || node.showLine === false) ? node.showLine : false
                }

                // 默认选中项，优先取$scope.passenger，不存在则取value值
                if (node.canSelect) {
                    const vo = this.vnode.data.model.expression.split('.')[0]
                    const passenger = this.vnode.context[vo] ? this.vnode.context[vo].passenger : null
                    if (passenger && passenger[attr.name]) {
                        if (passenger[attr.name] instanceof Array) {
                            for (let pIndex = 0; pIndex < passenger[attr.name].length; pIndex++) {
                                if (passenger[attr.name][pIndex].id === node.id) {
                                    node.checked = true
                                    break
                                }
                            }
                        } else if (passenger[attr.name].indexOf(node.id) !== -1) {
                            node.checked = true
                        }
                    } else if (this.prevSelected.length > 0 && this.prevSelected[0] !== '') {
                        for (let j = 0; j < this.prevSelected.length; j++) {
                            const selected = this.prevSelected[j]
                            let title = node.title
                            if (selected.indexOf('\\') === -1 && title.indexOf('\\') > 0) {
                                title = title.substring(title.lastIndexOf('\\') + 1)
                            }

                            const account = node.name + '/' + node.account
                            if (selected === node.id || selected === node.personId || (selected === node.name && this.binding.value !== 'suborg' && this.binding.value !== 'suborgExt') || selected === title || selected === account || (node.code && selected === node.code)) {
                                node.checked = true
                                node.selectedIndex = j
                                this.prevSelected[j] = 'removed'
                                // this.prevSelected.splice(j--, 1)
                                break
                            }
                        }
                    }

                    if (node.checked) {
                        const selectedNode = _this.selectedNodes.filter(tnode => {
                            return node.id === tnode.id
                        })

                        if (selectedNode.length === 0) {
                            _this.selectedNodes.push(node)
                            _this.defaultCheckedKeys.push(node.id)
                            // _this.defaultExpandedKeys.push(...node.orgFullId.split('-'))
                        }
                    }
                }
            }

            if (!this.lazy) {
                // 转换成树结构
                let level1Data = this.getChildren(treeData, null)

                if (level1Data.length > 0) {
                    level1Data = level1Data.filter(item => item.name !== '部门文件')
                    level1Data.forEach(data => {
                        data.children = this.getChildren(treeData, data)
                    })
                }
                treeData = level1Data
            }

            if (this.binding.value === 'wfNodeUser' && this.showSelectByTabs === true) {
                if (this.selectByTabsActiveName === 'byOrg') {
                    this.byOrgTreeData = treeData
                } else if (this.selectByTabsActiveName === 'byWorkgroup') {
                    this.byWgTreeData = treeData
                } else if (this.selectByTabsActiveName === 'byJobPosition') {
                    this.byJbTreeData = treeData
                }
            }

            // treeData格式必须遵循ztreeview treeNode规范
            return treeData
        },
        lazyLoadDefaultChecked(oldValue) {
            let orgCode = this.el.attrs['root-org-code']
            if (orgCode === undefined) {
                orgCode = this.loginUser.orgCode
            }

            oldValue = oldValue.filter(v => {
                return v !== 'removed'
            })
            if (oldValue.length > 0) {
                const reqParams = { method: 'POST', url: 'base/organMgr/findLazyLoadDefaultChecked', data: oldValue, params: { selectType: this.binding.value, orgCode: orgCode }}
                this.$http(reqParams).then(res => {
                    if (res.code === 'success') {
                        this.treeDataAdapter(res.body.listdata)// 数据格式化时会追加到已选择列表
                    }
                })
            }
        },
        // 查询子节点
        loadNode(node, resolve) {
            const _this = this
            new Promise((resolve, reject) => {
                if (node.data && (node.data.type === 'rootOrg' || node.data.orgLevel === 1) && _this.binding.value !== 'rootorg' && node.childNodes.length === 0) {
                    const reqParams = { method: 'GET', url: 'base/organMgr/findTreeNodeVOListByOrgId', params: { orgId: node.data.id, self: false, status: 1 }}

                    this.$http(reqParams).then(res => {
                        if (res.code === 'success') {
                            this.treeData.push(...this.treeDataAdapter(res.body.listdata))
                        } else {
                            this.$alert(res.message, { type: 'error' })
                            reject(res.message)
                        }

                        resolve(true)
                    })
                } else if (node.data && node.data.type === 'subOrg' && node.childNodes.length === 0 && node.data.olevel === 2 &&
                (this.binding.value === 'allStaff' || this.binding.value === 'staffExt' || this.binding.value === 'allNode' || this.binding.value === 'curOrgNode')) {
                    const listdataUrl = 'base/organMgr/queryLinkManByPager?orgId=' + node.data.id
                    const pager = { pageNum: 1, pageSize: 10000 }

                    this.$app.listdata(listdataUrl, pager)
                        .then(res => {
                            if (res.code === 'success') {
                                this.treeData = this.treeDataAdapter(res.body.pageInfo.list).concat(this.treeData)

                                resolve(true)

                                if (res.body.pageInfo.list.length === 0) {
                                    setTimeout(() => {
                                        node.isLeaf = false
                                    }, 0)
                                }
                            } else {
                                this.$alert(res.message, { type: 'error' })
                                reject(res.message)
                            }
                        })
                } else {
                    resolve(true)
                }
            }).then((res) => {
                if (res) {
                    let children = []
                    if (node.level === 0) {
                        children = this.getChildren(_this.treeData, null)

                        if (children.length === 1 && this.defaultExpandedKeys.length === 0) {
                            this.defaultExpandedKeys.push(children[0].id)
                        }
                    } else {
                        children = this.getChildren(_this.treeData, node.data)
                    }
                    resolve(children)

                    setTimeout(() => {
                        if (children.length > 0) {
                            this.selectedNodes.forEach(selectedNode => {
                                this.$refs.orgTree.setChecked(selectedNode, true, false)
                            })
                        }
                    }, 10)
                }
            })
        },
        getChildren(treeData, nodeData) {
            const children = []
            if (treeData.length === 0) return children

            if (!nodeData) {
                let firstPid = treeData[0].pId
                const treeNodeIds = []
                if (this.binding.value === 'staff' || this.binding.value === 'jobPositionStaff' || this.binding.value === 'workgroupStaff' || this.binding.value === 'wfNodeUser' || this.binding.value === 'rootorg') {
                    const suborgList = treeData.filter(node => {
                        if (node.type === 'treeNode') {
                            treeNodeIds.push(node.id)
                        }
                        return (node.type === 'subOrg' || node.orgLevel > 1 || node.olevel > 1 || node.type === 'treeNode')
                    })

                    if (suborgList.length > 0) {
                        firstPid = suborgList[0].pId
                    }
                }

                for (let i = 0; i < treeData.length; i++) {
                    const tnode = treeData[i]
                    if (tnode.pId === firstPid || tnode.parentId === firstPid || (this.binding.value === 'rootorg' && treeNodeIds.length === 0)) {
                        children.push(tnode)
                        treeData.splice(i, 1)
                        i--
                    }
                }
            } else {
                for (let i = 0; i < treeData.length; i++) {
                    const tnode = treeData[i]

                    if ((tnode.pId || tnode.parentID || tnode.parentId || tnode.orgId) === nodeData.id) {
                        children.push(tnode)

                        if (!this.lazy && (tnode.type === 'subOrg' || tnode.orgLevel > 1 || tnode.olevel > 1 || tnode.type === 'treeNode')) {
                            tnode.children = this.getChildren(treeData, tnode)
                        }
                    }
                }
                if (this.binding.value === 'staff' || this.binding.value === 'jobPositionStaff' || this.binding.value === 'workgroupStaff' || this.binding.value === 'wfNodeUser' || this.binding.value === 'rootorg') {
                    if (children.length === 0 && (nodeData.type === 'subOrg' || nodeData.orgLevel > 1 || nodeData.olevel > 1)) {
                        children.push({ 'title': '无', 'name': '无', disabled: true, 'personId': 'null' })
                    }
                }
            }
            return children
        },
        searchTreeNode() {
            if (!this.lazy || !this.searchkey) {
                this.searchDoing = false
                this.searchedData = null
                this.$refs.orgTree.filter(this.searchkey)
            } else {
                const _this = this
                _this.searchDoing = true
                _this.searchedData = null

                const searchedData = []
                new Promise((resolve, reject) => {
                    let searchStaff = false
                    let searchNode = false
                    if (this.binding.value === 'allStaff' || this.binding.value === 'staffExt' || this.binding.value === 'allNode' || this.binding.value === 'curOrgNode') {
                        const listdataUrl = 'base/organMgr/queryLinkManByPager'

                        const pager = { pageNum: 1, pageSize: 100, searchMap: {}}
                        pager.searchAndOr = 'or'
                        pager.searchMap['name'] = this.searchkey
                        pager.searchMap['account'] = this.searchkey
                        pager.searchMap['mobile'] = this.searchkey
                        pager.searchMap['positionName'] = this.searchkey

                        this.$app.listdata(listdataUrl, pager)
                            .then(res => {
                                if (res.code === 'success') {
                                    searchedData.push(... _this.treeDataAdapter(res.body.pageInfo.list))
                                }
                                searchStaff = true
                                if (searchStaff && searchNode) resolve(true)
                            })
                    } else {
                        searchStaff = true
                    }

                    if (this.binding.value === 'allOrg' || this.binding.value === 'allNode' || this.binding.value === 'curOrgNode' || this.binding.value === 'suborgExt') {
                        const reqParams = { method: 'GET', url: 'base/organMgr/findTreeNodeVOListByKeyword', params: { keyword: this.searchkey }}

                        this.$http(reqParams).then(res => {
                            if (res.code === 'success') {
                                searchedData.push(...this.treeDataAdapter(res.body.listdata))
                            }
                            searchNode = true
                            if (searchStaff && searchNode) resolve(true)
                        })
                    } else {
                        searchNode = true
                    }
                    if (searchStaff && searchNode) resolve(true)
                }).then((res) => {
                    _this.searchedData = searchedData
                    setTimeout(() => {
                        this.selectedNodes.forEach(selectedNode => {
                            this.$refs.searchOrgTree.setChecked(selectedNode, true, false)
                        })
                    }, 100)
                })
            }
        },
        getPrevSelected() {
            let pSelected = ''
            if (this.vnode.data.attrs['old-value']) {
                pSelected = this.vnode.data.attrs['old-value']
            } else if (this.el.value !== undefined && this.el.value !== null && this.el.value !== '') {
                pSelected = this.el.value
            } else if (this.vnode.data.model.value !== undefined && this.vnode.data.model.value !== null && this.vnode.data.model.value !== '') {
                pSelected = this.vnode.data.model.value
            } else {
                const model = this.vnode.data.model.expression.split('.')
                if (this.vnode.context[model[0]]) {
                    if (model.length === 2) {
                        pSelected = this.vnode.context[model[0]][model[1]] || ''
                    } else if (model.length === 3) {
                        pSelected = this.vnode.context[model[0]][model[1]][model[1]] || ''
                    } else {
                        pSelected = this.vnode.context[model[0]] || ''
                    }
                }
            }

            if (this.showSelectByTabs && this.selectedNodes.length > 0) {
                this.selectedNodes.forEach(item => {
                    if (pSelected !== '') pSelected += ','
                    pSelected += item.id
                })
            }

            if (this.el.attrs['separate']) {
                return pSelected.split(this.el.attrs['separate'])
            } else {
                return pSelected.replace(/、/g, ',').replace(/;/g, ',').replace(/，/g, ',').split(',')
            }
        },
        filterOrgTreeNode(value, data) {
            if (!value) return true

            return data.title.indexOf(value) !== -1
        },
        isLeafNode(data, node) {
            if (this.binding.value === 'workgroup' || this.binding.value === 'jobPosition') {
                return true
            } else if (this.binding.value === 'rootorg' && data.type === 'rootOrg') {
                return true
            } else if (this.binding.value === 'suborg' || this.binding.value === 'allOrg' || this.binding.value === 'suborgExt') {
                if (data.type && data.type !== 'subOrg') {
                    return false
                } else if (data.orgLevel === 1) {
                    return false
                } else {
                    const children = this.treeData.filter(treeNode => {
                        return (treeNode.parentId || treeNode.parentID) === data.id
                    })
                    return children.length === 0
                }
            } else if (data.personId) return true
            return false
        },
        // 节点点击事件
        onTreeNodeClick(data, nodeData, treeNode) {
            if (nodeData.isLeaf && !data.disabled) {
                if (this.searchDoing) {
                    this.$refs.searchOrgTree.setChecked(nodeData, !nodeData.checked, false)
                    this.onTreeNodeCheck(data, { checkedKeys: this.$refs.searchOrgTree.getCheckedKeys() })
                } else {
                    this.$refs.orgTree.setChecked(nodeData, !nodeData.checked, false)
                    this.onTreeNodeCheck(data, { checkedKeys: this.$refs.orgTree.getCheckedKeys() })
                }
            }
        },
        onTreeNodeExpand(data, nodeData, treeNode) {
            if (nodeData.childNodes.length > 0) {
                this.selectedNodes.forEach(selectedNode => {
                    this.$refs.orgTree.setChecked(selectedNode, true, false)
                })
            }
        },
        onTreeNodeCheck(data, checked) {
            if (!this.multiple) {
                this.selectedNodes = []
                this.$refs.orgTree.setCheckedKeys([])
                if (checked.checkedKeys.indexOf(data.id) !== -1) {
                    this.$refs.orgTree.setChecked(data, true, false)
                } else {
                    this.$refs.orgTree.setChecked(data, false, false)
                }
                if (this.searchDoing) {
                    this.$refs.searchOrgTree.setCheckedKeys([])
                    if (checked.checkedKeys.indexOf(data.id) !== -1) {
                        this.$refs.searchOrgTree.setChecked(data, true, false)
                    } else {
                        this.$refs.searchOrgTree.setChecked(data, false, false)
                    }
                }
            }

            if (this.checkStrictly || this.onebyone || this.selectedOrderBy === 'selectedIndex') {
                if (checked.checkedKeys.indexOf(data.id) !== -1) {
                    if (this.onebyone) {
                        for (let i = 0; i < this.selectedNodes.length; i++) {
                            if (data.groupId && this.selectedNodes[i].groupId === data.groupId) {
                                this.$refs.orgTree.setChecked(this.selectedNodes[i], false, false)
                                this.selectedNodes.splice(i--, 1)
                            } else if (data.orgFullId && data.orgFullId.indexOf('-') !== -1 && this.selectedNodes[i].orgFullId && this.selectedNodes[i].orgFullId.indexOf('-') !== -1) {
                                if (data.orgFullId.split('-')[1] === this.selectedNodes[i].orgFullId.split('-')[1]) {
                                    this.$refs.orgTree.setChecked(this.selectedNodes[i], false, false)
                                    this.selectedNodes.splice(i--, 1)
                                }
                            }
                        }
                    }
                    const selected = this.selectedNodes.filter(node => {
                        return node.id === data.id
                    })
                    if (selected.length === 0) {
                        this.selectedNodes.push(data)
                    }
                } else {
                    for (let i = 0; i < this.selectedNodes.length; i++) {
                        if (this.selectedNodes[i].id === data.id) {
                            this.selectedNodes.splice(i--, 1)
                        }
                    }
                }
            } else {
                this.selectedNodes = []
                const checkedFolderNodeKeys = []
                const leafOnly = !data.collapse
                const checkedNodes = this.$refs.orgTree.getCheckedNodes(leafOnly, false)
                checkedNodes.forEach(node => {
                    if (!node.personId) {
                        checkedFolderNodeKeys.push(node.id)
                    }
                    if (!node.personId && checkedFolderNodeKeys.indexOf(node.parentId) === -1) {
                        this.selectedNodes.push(node)
                    } else if (node.personId && checkedFolderNodeKeys.indexOf(node.orgId) === -1 && checkedFolderNodeKeys.indexOf(node.groupId) === -1) {
                        this.selectedNodes.push(node)
                    }
                })
            }
        },
        removeSelectedNode(removeNode) {
            this.$refs.orgTree.setChecked(removeNode, false, false)
            if (this.searchDoing) {
                this.$refs.searchOrgTree.setChecked(removeNode, false, false)
            }

            for (let i = 0; i < this.selectedNodes.length; i++) {
                if (this.selectedNodes[i].id === removeNode.id) {
                    this.selectedNodes.splice(i--, 1)
                }
            }
        },
        onSelectByTabsHandleClick(val) {
            // 机构全体人员，按机构、按岗位、按群组标签点击
            const _this = this
            _this.treeData = []
            _this.searchkey = ''

            const orgCodes = []
            _this.byOrgTreeData.forEach(item => {
                if (item.isRealOrg === 1 && item.orgLevel === 1) {
                    orgCodes.push(item.code)
                }
            })
            if (orgCodes.length === 0) {
                orgCodes.push(_this.loginUser.orgCode)
            }
            let treeData = null
            const reqParams = {
                method: 'POST',
                url: 'workflow/wfInstance/getWfNodeUsers',
                params: { orgCodes: orgCodes.join(), byType: val }
            }

            if (val === 'byWorkgroup') {
                treeData = this.byWgTreeData
            } else if (val === 'byJobPosition') {
                treeData = this.byJbTreeData
            } else {
                treeData = this.byOrgTreeData
            }

            if (treeData === null) {
                this.$http(reqParams).then(res => {
                    if (res.code === 'success') {
                        this.treeData = this.treeDataAdapter(res.body.listdata)
                    } else {
                        this.$alert(res.message, { type: 'error' })
                    }
                })
            } else {
                if (this.showSelectByTabs && this.selectedNodes.length > 0) {
                    let pSelected = ''
                    this.selectedNodes.forEach(item => {
                        if (pSelected !== '') pSelected += ','
                        pSelected += item.id
                    })
                    if (pSelected !== '') {
                        treeData.forEach(item => {
                            if (pSelected.indexOf(item.id) !== -1) {
                                for (let k = 0; k < this.selectedNodes.length; k++) {
                                    if (this.selectedNodes[k].id === item.id) this.selectedNodes.splice(k--, 1)
                                }
                                this.selectedNodes.push(item)

                                item.checked = true
                            }
                        })
                    }
                }

                _this.treeData = treeData
            }
        },
        submitForm() {
            const _this = this
            const model = this.vnode.data.model.expression.split('.')

            new Promise((resolve, reject) => {
                const prevSelected = this.getPrevSelected()

                if (this.selectedNodes.length === 0 && prevSelected.length > 0) {
                    this.$confirm('是否确认清除已选？', '确认操作', { type: 'warning' }).then(() => {
                        resolve(true)
                    }).catch(err => {
                        reject(err)
                    })
                } else {
                    resolve(true)
                }
            }).then(async() => {
                const selectedNodes = []
                _this.selectedNodes.forEach(node => {
                    if (node.collapse && !node.personId) {
                        if (node.children) {
                            node.children.forEach(tnode => {
                                if (!tnode.children) {
                                    selectedNodes.push(tnode)
                                } else {
                                    tnode.children.forEach(ttnode => {
                                        if (!ttnode.children) {
                                            selectedNodes.push(ttnode)
                                        } else {
                                            selectedNodes.push(...ttnode.children)
                                        }
                                    })
                                }
                            })
                        }
                    } else {
                        selectedNodes.push(node)
                    }
                })

                if (_this.vnode.context[_this.callback] !== undefined) {
                    await _this.vnode.context[_this.callback](selectedNodes, _this.el.attrs)
                } else if (_this.vnode.context.$vnode.context[_this.callback] !== undefined) {
                    await _this.vnode.context.$vnode.context[_this.callback](selectedNodes, _this.el.attrs)
                } else if (_this.vnode.context.$vnode.context.$vnode.context[_this.callback] !== undefined) {
                    await _this.vnode.context.$vnode.context.$vnode.context[_this.callback](selectedNodes, _this.el.attrs)
                } else {
                    let selected = ''
                    selectedNodes.forEach(function(node) {
                        if (selected !== '') selected += '、'
                        selected += node.name
                    })

                    if (model[0] === 'formItem' && this.vnode.context['valueChange'] !== undefined) {
                        this.vnode.context['valueChange'](selected)
                    }
                    if (this.vnode.context[model[0]]) {
                        if (model.length === 2) {
                            this.vnode.context.$set(this.vnode.context[model[0]], model[1], selected)
                        } else {
                            this.vnode.context.$set(this.vnode.context, model[0], selected)
                        }
                    }
                }

                if (this.vnode.context[model[0]]) {
                    if (model.length === 2) {
                        this.vnode.data.model.value = this.vnode.context[model[0]][model[1]] || ''
                    } else if (model.length === 3) {
                        this.vnode.data.model.value = this.vnode.context[model[0]][model[1]][model[1]] || ''
                    } else {
                        this.vnode.data.model.value = this.vnode.context[model[0]] || ''
                    }

                    if (model[0] === 'formItem' && this.vnode.context['valueChange'] !== undefined) {
                        this.vnode.context['valueChange'](this.vnode.data.model.value)
                    }
                }

                this.vnode.context.$forceUpdate()
                this.closeDialog()
            })
        },
        closeDialog() {
            this.dialogFormVisible = false
            this.loading = false
            this.winWidth = 600
            this.el = null
            this.binding = null
            this.vnode = null
            this.dialogName = null
            this.treeData = null
            this.selectedNodes = []
            this.rootTreeData = null
            this.selectRootOrg = ''
            this.rootOrgList = []
            this.subOrgList = {}
            this.searchkey = ''
            if (window.fontMagnify !== undefined)window.fontMagnify = false
        }
    }
}
</script>

<style scoped lang="scss">
.search-input-container{
    padding: 8px;
    /deep/ .el-input-group__prepend{
        width: 100px;
        background-color:#fff;
        color:#333;
        border-bottom-right-radius: 0px;
        border-top-right-radius: 0px;
    }
}

.ztree-container{
    height:350px;

    /deep/ .el-tabs--top{
        margin-top: 0px;

        .el-tabs__header{
            margin: 0px;
            border-bottom: solid 1px #dfe6ec;
        }

        .el-tabs__nav-wrap::after{
            height:0px;
        }
    }
    .el-tree{
        overflow-x: hidden;
    }
    .hidden-folder-checkbox{
        /deep/ .el-tree-node {
            .is-leaf + .el-checkbox .el-checkbox__inner {
                display: inline-block;
            }

            .el-checkbox__input .el-checkbox__inner {
                display: none;
            }
        }
    }

    .selectedNodes{
        width: 100%;
        padding: 10px;
        .selectedNode{
            background-color: #F1F4F7;
            margin-bottom: 4px;
            padding: 6px 8px;

            .node-text{
                 width: calc(100% - 15px);
                white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
            }

            .el-icon-close{
                float: right;
                cursor: pointer;
                color: #ff0000;
                margin-top: -14px;
            }
        }

        .selected-title{
            font-weight: 600;
            height: 32px;
            line-height: 32px;
            margin-top: -5px;
        }
    }
}

.treeNode{
    border:1px solid #dfe6ec;
    height: 100%;
    .el-scrollbar{
        height: 300px;
    }
    .no-search-input{
        height: 327px;
        margin-top: 10px;
    }

    /deep/ .el-scrollbar__wrap{
        overflow-x: hidden;
    }

    .tree-node-icon{
        i {
            margin-right:7px;
            margin-left:-7px;
            font-size: var(--portalFontSize14);
        }
    }
}
.searchdoing{
    /deep/ .el-loading-mask{background-color: rgba(255,255,255,1)}
}

</style>
